module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xitongxiaoxi"
  }, [_c('div', {
    staticClass: "xt-title"
  }, [_vm._v(_vm._s(_vm.$t('all.wodedingdan')))]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "xt-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "dd-list-item"
    }, [_c('div', {
      staticClass: "dd-list-item-top"
    }, [_c('div', {
      staticClass: "dd-list-item-top-left"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/image/zhibo_14@2x.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.liveInfo.name))])]), _vm._v(" "), _c('span', {
      staticClass: "dd-list-item-top-span"
    }, [_vm._v(_vm._s(item.orderStatusName))])]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-goods"
    }, [_c('img', {
      attrs: {
        "src": item.goodsInfo.mediasList[0].uri,
        "alt": ""
      },
      on: {
        "error": _vm.handleImgError
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-goods-content"
    }, [_c('div', {
      staticClass: "dd-list-item-goods-content-name"
    }, [_vm._v(_vm._s(item.goodsInfo.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-goods-content-price"
    }, [_c('div', {
      staticClass: "dd-list-item-goods-content-price-left"
    }, [_c('span', {
      staticClass: "dd-list-item-goods-content-price-left-span1"
    }, [_vm._v("USDN" + _vm._s(item.goodsInfo.specificationList[0].price))])]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-goods-content-price-right"
    }, [_vm._v("x" + _vm._s(item.number))])])])]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-bottom"
    }, [_vm._v(_vm._s(_vm.$t('all.dingdanjine')) + "：USDN" + _vm._s(item.orderPrice))]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-no"
    }, [_c('span', {
      staticClass: "dd-list-item-no-span"
    }, [_vm._v(_vm._s(_vm.$t('all.dingdanbianhao')))]), _vm._v(" "), _c('span', {
      staticClass: "dd-list-item-no-span1"
    }, [_vm._v(_vm._s(item.orderOn))])]), _vm._v(" "), _c('div', {
      staticClass: "dd-list-item-no"
    }, [_c('span', {
      staticClass: "dd-list-item-no-span"
    }, [_vm._v(_vm._s(_vm.$t('all.chuangjianshijian')))]), _vm._v(" "), _c('span', {
      staticClass: "dd-list-item-no-span1"
    }, [_vm._v(_vm._s(item.createTime))])])])
  }), _vm._v(" "), (!_vm.hasMore && _vm.list.length === 0) ? _c('kong') : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11ce1af7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wodedingdan/wodedingdan.vue
// module id = 953
// module chunks = 1